export default class PermissionManager {

    constructor() {
        this._PERMISSIONTYPES = {
            STACKUP: { key: "STACKUP", userTypeAccess: [0, 1, 2, 3, 4, 5] },
            STACKUPFREE: { key: "STACKUPFREE", userTypeAccess: [0, 6] },
            METRICS: { key: "METRICS", userTypeAccess: [0, 1, 2, 3, 4, 5] },
            METRICS_FORCEBLAST: { key: "METRICS_FORCEBLAST", userTypeAccess: [0] },
            METRICS_ALLPEEPS: { key: "METRICS_ALLPEEPS", userTypeAccess: [0, 1, 2, 3, 4, 5] },
            METRICS_ALLLOCATIONS: { key: "METRICS_ALLLOCATIONS", userTypeAccess: [0, 1, 2, 3, 4, 5] },
            METRICS_EMPLOYEENAMES: { key: "METRICS_EMPLOYEENAMES", userTypeAccess: [0, 1, 2, 3, 4, 5] },
            REPORTING: { key: "REPORTING", userTypeAccess: [0, 1, 2, 3, 4] },
            CHAT: { key: "CHAT", userTypeAccess: [0] },
            GROUPS: { key: "GROUPS", userTypeAccess: [0, 1] },
            MANGEMENT: { key: "MANGMENT", userTypeAccess: [0, 1, 2, 3, 4] },
            MANGEMENT_CONTESTS: { key: "MANGEMENT_CONTESTS", userTypeAccess: [0, 1, 2, 3, 4] },
            MANGEMENT_GOALS: { key: "MANGEMENT_GOALS", userTypeAccess: [0, 1, 2, 3, 4] }
            /*WORKSPACES: { key: "WORKSPACES", userTypeAccess: [0, 1, 2, 3, 4, 5] } */
        };

        this.setUserType = this.setUserType.bind(this);
        this.clearUserType = this.clearUserType.bind(this);
        this.getUserType = this.getUserType.bind(this);
        this.hasAccess = this.hasAccess.bind(this);
    }

    get PERMISSIONS() {
        return this._PERMISSIONTYPES;
    }

    setUserType(userTypeId) {
        window.localStorage.setItem("LoggedInUserTypeId", userTypeId);
    }

    clearUserType(userTypeId) {
        window.localStorage.removeItem("LoggedInUserTypeId");
    }

    getUserType() {
        var userTypeId = JSON.parse(window.localStorage["LoggedInUserTypeId"]);
        if (userTypeId != undefined && userTypeId != null) {
            return userTypeId;
        }
        else {
            return -1;
        }
    }

    hasAccess(p) {
        // return (p.userTypeAccess.indexOf(this.getUserType()) > -1);
        let userType = this.getUserType();
        return (p.userTypeAccess.includes(userType));
    }
}